import DisableFeatureInfoModalComponent from "./DisableFeatureInfoModalComponent";

export default DisableFeatureInfoModalComponent;
